import { useState, useCallback, useEffect, Dispatch, SetStateAction, useMemo } from 'react';
import { opportunitiesDefaultStates } from '../OpportunitiesDefaultStates';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';
import { IProjectAttributes } from 'shared/interfaces/IProject';
import { useQueryClient } from 'react-query';
import { OPPORTUNITIES_QUERY_STRING } from 'shared/constants/QUERY_STRING';

const { getOpportunities, removeProjects } = opportunitiesServices();
export const useNotInterestedOpportunities = (
  setNotInterestedDataState: Dispatch<SetStateAction<IProjectAttributes[]>>,
  notInterestedDataState: IProjectAttributes[],
  setOpportunities: Dispatch<SetStateAction<IProjectAttributes[]>>,
) => {
  const queryClient = useQueryClient();
  const { mutate: removeProjectsMutation } = removeProjects();

  const [enabled, setEnabled] = useState(false);
  const {
    data,
    fetchNextPage: fetchNotInterested,
    hasNextPage: notInterestedHasNextPage,
    isLoading: notInterestedFetching,
    isFetchingNextPage: notInterestedRefetching,
  } = getOpportunities(
    {
      tab_filter: 'not_interested',
    },
    {
      enabled,
    },
  );

  const notInterestedData = useMemo(() => {
    const lastPage = data?.pages[data.pages.length - 1];

    return data ? lastPage?.data.opportunities_connection.nodes : [];
  }, [data]);

  const fetchMoreNotInterested = useCallback(() => {
    if (notInterestedHasNextPage && !notInterestedRefetching) {
      fetchNotInterested();
    }
  }, [fetchNotInterested, notInterestedHasNextPage, notInterestedRefetching]);

  const getNotInterestedOpportunities = useCallback(() => {
    if (enabled) return;
    setNotInterestedDataState([]);
    setEnabled(true);
  }, [setNotInterestedDataState, enabled]);

  const pushProjectToOpportunities = useCallback(
    (project: IProjectAttributes) => {
      setNotInterestedDataState((prev) => prev.filter((opportunity) => opportunity.id !== project.id));
      setOpportunities((prevOpportunities) => prevOpportunities.concat(project));
    },
    [setOpportunities, setNotInterestedDataState],
  );

  const reactivateProject = useCallback(
    (projectId: string) => {
      // const updatedProjects = notInterestedDataState.filter((project) => project.id !== projectId);
      setNotInterestedDataState((prev) => prev.filter((opportunity) => opportunity.id !== projectId));
      removeProjectsMutation(
        {
          ids: [projectId],
        },
        {
          onSuccess: () => {
            const project = notInterestedDataState.find((project) => project.id === projectId);
            console.log('project', project);

            if (project) {
              console.log('PUSH mo');

              pushProjectToOpportunities(project);
            }
            queryClient.invalidateQueries(OPPORTUNITIES_QUERY_STRING.OPPORTUNITIES_TAB_AGGREGATES);
          },
        },
      );
    },
    [
      notInterestedDataState,
      pushProjectToOpportunities,
      removeProjectsMutation,
      queryClient,
      setNotInterestedDataState,
    ],
  );

  useEffect(() => {
    //staggered fetching
    if (notInterestedDataState.length < 2 && notInterestedHasNextPage) {
      fetchMoreNotInterested();
    }
  }, [notInterestedDataState, notInterestedHasNextPage, fetchMoreNotInterested]);

  useEffect(() => {
    if (!notInterestedData) return;
    setNotInterestedDataState((prev) => prev.concat(notInterestedData));
  }, [notInterestedData, setNotInterestedDataState]);

  return {
    reactivateProject,
    getNotInterestedOpportunities,
    notInterestedFetching,
    fetchMoreNotInterested,
    notInterestedRefetching,
    setNotInterestedDataState,
  };
};
